var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{attrs:{"label":_vm.$t('field.public')},on:{"change":function($event){return _vm.changed()}},model:{value:(_vm.isPublic),callback:function ($$v) {_vm.isPublic=$$v},expression:"isPublic"}})}
var staticRenderFns = []

export { render, staticRenderFns }